import { RouteComponentProps } from 'react-router'

// 将URL参数转换为对象
export const getQueryParams = (query = '') => {
  const result = Object.create(null)
  if (!query) {
    return result
  }
  const queryString = query.startsWith('?') ? query.substr(1) : query
  return queryString.split('&').reduce((res, cur) => {
    const [k, v] = cur.split('=')
    res[k] = v
    return res
  }, result)
}

// 将对象转化为url字符串
export const getQueryString = (params: any): string => {
  let result = ''
  Object.keys(params).forEach(key => {
    result += `&${key}=${params[key]}`
  })
  return result ? `?${result.substr(1)}` : ''
}

const redirectRoutes = [
  '/',
  '/login',
  '/one-login',
  '/sifang-login',
  '/register',
  '/retrievePassword',
]

const ifNeedRedirect = () => {
  const hashRoute = location.hash.split('?')[0]
  const target = redirectRoutes.findIndex(route => hashRoute === `#${route}`)
  return target > -1
}
/**
 * 通过url上传递route参数，登录后直接进入或打开对应页面
 * @param history
 * @example:
 *  1. http://localhost:3000/#/login?route=/home/paper
 *  2. http://localhost:3000/#/login?route=http://www.baidu.com
 */
export const directTo = (
  history: RouteComponentProps['history'],
  url = '/home/homePage'
) => {
  // 登录、注册、找回密码等页面重定向，其它不处理
  const needRedirect = ifNeedRedirect()
  if (!needRedirect) {
    return
  }

  const { href } = window.location
  const [_, query] = href.split('?')
  const moveTo = (path = url) => {
    setTimeout(() => history.push(path), 0)
  }

  if (!query) {
    moveTo()
    return
  }

  const params = getQueryParams(query)
  const secretValue = params.secretValue
    ? `secretValue=${params.secretValue}&`
    : ''
  let extParam = ''
  if (params.route) {
    Object.keys(params).map(key => {
      if (key === 'secretValue' || key === 'viewFrom' || key === 'route') return
      extParam = `${key}=${params[key]}`
    })
  }
  const viewFrom = params.viewFrom ? `viewFrom=${params.viewFrom}&` : ''
  const route = params.route && `${params.route}?${secretValue}${viewFrom}${extParam}`
  if (!route) {
    moveTo()
    return
  }
  if (route.indexOf('http') === 0) {
    // 打开新页面会被浏览器拦截，改为替换当前Tab页
    document.location.assign(decodeURIComponent(route))
  } else {
    moveTo(route)
  }
}

export const getHashRoute = () => location.hash.split('?')[0].split('/')[1]
